@let udestaaende = opkraevningUdestaaendeService.selectedUdestaaende();
@if (udestaaende) {
  <p-scroll-panel class="h-full">
    <h2>Udestående opkrævning</h2>
    <table class="detail-table">
      <tr>
        <td class="detail-label">Regnr</td>
        <td>{{ udestaaende.hovedRegNr }}</td>
      </tr>
      <tr>
        <td class="detail-label">Forsikringstager</td>
        <td>{{ udestaaende.forsikringstagerCpr | cprNummer }}</td>
      </tr>
      <tr>
        <td class="detail-label">Letsikring nr</td>
        <td>{{ udestaaende.letsikringNr }}</td>
      </tr>
      <tr>
        <td class="detail-label">Police nr</td>
        <td>{{ udestaaende.policeNr }}</td>
      </tr>
      <tr>
        <td class="detail-label">Opkrævningsbeløb</td>
        <td>{{ udestaaende.opkraevningsBeloeb | number: '1.2' }}</td>
      </tr>
      <tr>
        <td class="detail-label">Periode</td>
        <td>
          {{ udestaaende.periodeFra | date: 'dd-MM-yyyy' }} -
          {{ udestaaende.periodeTil | date: 'dd-MM-yyyy' }}
        </td>
      </tr>
      <tr>
        <td class="detail-label">Debitering regnr</td>
        <td>{{ udestaaende.filialRegnr }}</td>
      </tr>
      <tr>
        <td class="detail-label">Årsag</td>
        <td>{{ udestaaende.aarsag }}</td>
      </tr>
    </table>

    @let tilknyttet = opkraevningUdestaaendeService.tilknyttetOpkraevning();
    <h2>Tilknyttet risiko opkrævning</h2>
    @if (tilknyttet) {
      <table class="detail-table">
        <tr>
          <td class="detail-label">Opkrævningsstatus</td>
          <td>{{ tilknyttet.opkraevningStatus }}</td>
        </tr>
        <tr>
          <td class="detail-label">Opkrævningsreference</td>
          <td>{{ tilknyttet.id }}</td>
        </tr>
        <tr>
          <td class="detail-label">Opkrævningsbeløb</td>
          <td>{{ tilknyttet.opkraevningsBeloeb | number: '1.2' }}</td>
          @if (allowRettelse()) {
            @if (retBeloeb()) {
              <td>
                <div class="flex gap-2">
                  <p-input-number
                    [(ngModel)]="nytBeloeb"
                    placeholder="Nyt beløb"
                    locale="da"
                    [maxFractionDigits]="2"
                    mode="decimal"></p-input-number>
                  <p-button label="Gem beløb" (click)="gemBeloeb()"></p-button>
                  <p-button
                    label="Fortryd"
                    outlined
                    (click)="retBeloeb.set(false)"></p-button>
                </div>
              </td>
            } @else {
              <td>
                <p-button
                  label="Ret beløb"
                  size="small"
                  outlined
                  (click)="retBeloeb.set(true)" />
              </td>
            }
          }
          <td></td>
        </tr>
        <tr>
          <td class="detail-label">Periode start</td>
          <td>{{ tilknyttet.periodeFra | date: 'dd-MM-yyyy' }}</td>
          @if (allowRettelse()) {
            @if (retPeriode()) {
              <td>
                <div class="flex gap-2">
                  <app-let-date-picker
                    [(ngModel)]="nyPeriodeFra"
                    placeholder="Periode start"
                    size="small"></app-let-date-picker>
                  <app-let-date-picker
                    [(ngModel)]="nyPeriodeTil"
                    placeholder="Periode slut"
                    size="small"></app-let-date-picker>
                  <p-button
                    label="Gem periode"
                    (click)="gemPeriode()"></p-button>
                  <p-button
                    label="Fortryd"
                    outlined
                    (click)="retPeriode.set(false)"></p-button>
                </div>
              </td>
            } @else {
              <td>
                <p-button
                  label="Ret periode"
                  size="small"
                  outlined
                  (click)="retPeriode.set(true)" />
              </td>
            }
          }
        </tr>
        <tr>
          <td class="detail-label">Periode slut</td>
          <td>{{ tilknyttet.periodeTil | date: 'dd-MM-yyyy' }}</td>
          <td></td>
        </tr>
        <tr>
          <td class="detail-label">Debitering regnr</td>
          <td>{{ tilknyttet.regnr }}</td>
          <td></td>
        </tr>
      </table>
    } @else {
      <div>Ingen tilknyttet risiko opkrævning</div>
    }

    @if (udestaaende.behandlet) {
      <h2>Behandlingsoplysninger</h2>
      <table class="detail-table">
        <tr>
          <td class="detail-label">Behandlingstidspunkt</td>
          <td>{{ udestaaende.behandlet | date: 'dd-MM-yyyy HH-mm' }}</td>
        </tr>
        <tr>
          <td class="detail-label">Behandlet af</td>
          <td>{{ udestaaende.behandletAf }}</td>
        </tr>
        <tr>
          <td class="detail-label">Behandlingskommentar</td>
          <td>{{ udestaaende.behandlingsKommentar }}</td>
        </tr>
      </table>
    }
    <div class="flex gap-2 mt-4">
      @if (
        !udestaaende.behandlet &&
        (tilknyttet?.opkraevningStatus !== 'ClearingFejl' || !tilknyttet)
      ) {
        <p-button
          label="Angiv som behandlet"
          (click)="visAngivSomBehandlet.set(true)"></p-button>
      }
      @if (!tilknyttet && !udestaaende.behandlet) {
        <p-button label="Tilknyt opkrævning" (click)="visTilknyt()"></p-button>
      }
    </div>
    @if (visTilknytOpkraevning()) {
      <p-panel
        header="Tilknyt opkrævning"
        [style]="{
          flex: 1,
          marginTop: '20px',
        }">
        <ng-template #icons>
          <p-button
            icon="pi pi-times"
            severity="secondary"
            rounded
            text
            (click)="visTilknytOpkraevning.set(false)" />
        </ng-template>
        <p-table
          [value]="muligeRisikoOpkraevninger()"
          selectionMode="single"
          [metaKeySelection]="true"
          [(selection)]="valgtOpkraevning"
          stripedRows
          class="p-datatable-sm lp-table">
          <ng-template pTemplate="header">
            <tr>
              <th>Reference</th>
              <th>Regnr</th>
              <th>CPR nr</th>
              <th>Periode</th>
              <th>LetsikringNr</th>
              <th>Revision</th>
              <th>Type</th>
              <th>Beløb</th>
              <th>Status</th>
            </tr>
          </ng-template>
          <ng-template
            [appTableRow]="muligeRisikoOpkraevninger()"
            pTemplate="body"
            let-item>
            <tr [pSelectableRow]="item">
              <td>{{ item.id }}</td>
              <td>{{ item.regnr }}</td>
              <td>{{ item.cprNummer | cprNummer }}</td>
              <td>
                {{ item.periodeFra | date: 'dd-MM-yyyy' }} -
                {{ item.periodeTil | date: 'dd-MM-yyyy' }}
              </td>
              <td>{{ item.letsikringNr }}</td>
              <td>{{ item.revisionNr }}</td>
              <td>{{ item.opkraevningsType }}</td>
              <td>{{ item.opkraevningsBeloeb | number: '1.2' }}</td>
              <td>{{ item.opkraevningStatus }}</td>
            </tr>
          </ng-template>
        </p-table>
        @if (valgtOpkraevning()) {
          <div class="mt-4">
            <p-button label="Gem" (click)="gemTilknytning()"></p-button>
          </div>
        }
      </p-panel>
    }
  </p-scroll-panel>
}
<p-dialog
  header="Angiv som behandlet"
  [modal]="true"
  [(visible)]="visAngivSomBehandlet"
  [style]="{
    width: '600px',
  }">
  <div>Kommentar</div>
  <div>
    <textarea
      style="width: 100%; height: 150px"
      pTextarea
      [(ngModel)]="kommentar"></textarea>
  </div>
  <p-button
    label="Gem"
    [disabled]="!allowGemKommentar()"
    (click)="angivSomBehandlet()"></p-button>
</p-dialog>
